import { SecuredClient } from '../../../Core/Api/SecuredClient';

export interface RoleDetail {
    id?: string;
    name?: string;
    description?: string;
    status?: number;
    creationDate?: string;
    permissionCount?: number;
}

export interface OperationItem {
    id?: string;
    name?: string;
    description?: string;
}

export class RoleManagementHandler {
    async getRoles(): Promise<any> {
        const client = new SecuredClient();
        client.showLoading = false;
        client.handleGeneralError = true;
        return client.getAllRoles();
    }

    async getRoleDetails(roleId: string): Promise<any> {
        const client = new SecuredClient();
        client.showLoading = false;
        client.handleGeneralError = true;
        const url = `${(client as any).baseUrl}/sa/sudokuvs/admin/commands/GetRoleDetails?RoleId=${encodeURIComponent(roleId)}`;
        const response = await client.axiosInstance.request({
            method: 'GET',
            url,
            headers: { 'Accept': 'text/plain' },
        });
        return response.data;
    }

    async getOperations(): Promise<any> {
        // GetRoleDetails returns AllOperations, but requires a RoleId.
        // Use the existing GetAllRoles to get role list, then get details of the first role
        // to fetch AllOperations. If no roles exist, return empty.
        const client = new SecuredClient();
        client.showLoading = false;
        client.handleGeneralError = true;
        const rolesResponse = await client.getAllRoles();
        const roles = (rolesResponse as any)?.results || [];
        if (roles.length === 0) {
            return { operations: [] };
        }
        const details = await this.getRoleDetails(roles[0].id);
        return { operations: (details?.allOperations || []).map((name: string) => ({ id: name, name })) };
    }

    async createRole(name: string, description: string, operationIds: string[]): Promise<any> {
        const client = new SecuredClient();
        client.showLoading = true;
        client.handleGeneralError = true;
        const url = `${(client as any).baseUrl}/sa/sudokuvs/admin/commands/CreateRole`;
        const content = JSON.stringify({ name, description, operations: operationIds });
        const response = await client.axiosInstance.request({
            data: content,
            method: 'POST',
            url,
            headers: {
                'Content-Type': 'application/json-patch+json',
                'Accept': 'text/plain',
            },
        });
        return response.data;
    }

    async updateRole(roleId: string, name: string, description: string, operationIds: string[]): Promise<any> {
        const client = new SecuredClient();
        client.showLoading = true;
        client.handleGeneralError = true;
        const url = `${(client as any).baseUrl}/sa/sudokuvs/admin/commands/UpdateRole`;
        const content = JSON.stringify({ roleId, name, description, operations: operationIds });
        const response = await client.axiosInstance.request({
            data: content,
            method: 'POST',
            url,
            headers: {
                'Content-Type': 'application/json-patch+json',
                'Accept': 'text/plain',
            },
        });
        return response.data;
    }

    async deleteRole(roleId: string): Promise<any> {
        const client = new SecuredClient();
        client.showLoading = true;
        client.handleGeneralError = true;
        const url = `${(client as any).baseUrl}/sa/sudokuvs/admin/commands/DeleteRole`;
        const content = JSON.stringify({ roleId });
        const response = await client.axiosInstance.request({
            data: content,
            method: 'POST',
            url,
            headers: {
                'Content-Type': 'application/json-patch+json',
                'Accept': 'text/plain',
            },
        });
        return response.data;
    }
}
